import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useCheckoutValidationStore = defineStore('checkoutValidation', () => {
    const validators = ref([]);

    function registerValidator(fn) {
        validators.value.push(fn);
    }

    function unregisterValidator(fn) {
        const validatorIndex = validators.value.indexOf(fn);
        if (validatorIndex !== -1) {
            validators.value.splice(validatorIndex, 1);
        }
    }

    async function validateAll() {
        const results = await Promise.all(validators.value.map(v => v()));
        return results.every(r => r.isValid);
    }

    return {
        registerValidator,
        unregisterValidator,
        validateAll,
    };
});
